module.exports = "/assets/ea0742663680d3c2c0494b6f4f2c5726.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/PC.png
// module id = 1711
// module chunks = 0